import React, { useState, useEffect } from 'react';
import { Card, Col, Container, Nav, Row, Accordion } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { validarEntorno } from '../../../../../helpers/validarHost';
import Alcance from './Alcance';
import DatosGenerales from './DatosGenerales';
import Definiciones from './Definiciones';
import Introduccion from './Introduccion';
import Objetivos from './Objetivos';
import Asignacion from './AsignacionAud';
import { ContainerD } from '../../../../../components/dashboard/Container'
import { useTranslation } from 'react-i18next';

const Main = () => {

  const [listItems, setListItems] = useState({});
  const [eventFormId, setEventFormId] = useState(1);
  const [activeFormKey, setActiveFormKey] = useState(1);
  const id = useParams();

  const { t } = useTranslation();

  const items = async () => {

    const dataSend = {
      id_gestion: id,
      hash: window.location.hash
    }

    const request = await validarEntorno('JSON/introduccion_del_informe_json.html', 'POST', dataSend);

    if (request.ok) {
      const respuesta = await request.json();

      setListItems(respuesta);
    }
  }

  useEffect(() => {
    items();
  }, [activeFormKey])

  const renderForm = () => {
    if (Object.keys(listItems).length !== 0) {
      switch (eventFormId) {
        case 1:
          return <DatosGenerales dataG={listItems.data.datos_generales} permisos={listItems.permisos} />
        case 2:
          return <Introduccion dataG={listItems.data.introduccion} permisos={listItems.permisos} />
        case 3:
          return <Objetivos dataG={listItems.data.objetivos} permisos={listItems.permisos} />
        case 4:
          return <Definiciones dataG={listItems.data.definiciones} permisos={listItems.permisos} />
        case 5:
          return <Alcance dataG={listItems.data.alcance} permisos={listItems.permisos} />
        case 6:
          return <Asignacion permisos={listItems.permisos} />
        case 7:
          return <ContainerD dataG={listItems.data.consolidado} />
        default:
          return <></>
      }
    }
  }

  const eventFormIdValue = (value) => {
    setEventFormId(value);
    setActiveFormKey(value);
  }

  return (
    <Card className='card__box__surface cardUnderPestana'>
      <Card.Body>
        <Row className="row-content">
          <Col xl={2} lg={3} md={4} xs={0} id="sidebar-wrapper">
            <Nav defaultActiveKey={activeFormKey} activeKey={activeFormKey} className="shadow p-2 flex-column nav-items">
              <Nav.Link className="item-a" eventKey="1" onClick={() => eventFormIdValue(1)}>
                {t("gestion_realizada.introduccion_informe.datos_generales")}
              </Nav.Link>
              <Nav.Link className="item-a" eventKey="2" onClick={() => eventFormIdValue(2)}>
                {t("gestion_realizada.introduccion_informe.introduccion")}
              </Nav.Link>
              <Nav.Link className="item-a" eventKey="3" onClick={() => eventFormIdValue(3)}>
                {t("gestion_realizada.introduccion_informe.objetivos")}
              </Nav.Link>
              <Nav.Link className="item-a" eventKey="4" onClick={() => eventFormIdValue(4)}>
                {t("gestion_realizada.introduccion_informe.definiciones")}
              </Nav.Link>
              <Nav.Link className="item-a" eventKey="5" onClick={() => eventFormIdValue(5)}>
                {t("gestion_realizada.introduccion_informe.alcance")}
              </Nav.Link>
              <Nav.Link className="item-a" eventKey="6" onClick={() => eventFormIdValue(6)}>
                {t("gestion_realizada.introduccion_informe.asignaciones")}
              </Nav.Link>
              {/*<Nav.Link className="item-a" eventKey="7" onClick={() => eventFormIdValue(7)}>
                                Consolidado
                             </Nav.Link>*/}

            </Nav>
          </Col>
          <Col xl={10} lg={9} md={8} xs={12} id="page-content-wrapper">
            {renderForm()}
          </Col>
        </Row>

      </Card.Body>

    </Card>
  );
};

export default Main;
